/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse";

import type { HTTPValidationError } from "../../models/hTTPValidationError";

import type { OnboardingProfileRequest } from "../../models/onboardingProfileRequest";

import type { OnboardingStatusResponse } from "../../models/onboardingStatusResponse";

import type { PostV1CompleteOnboardingStepParams } from "../../models/postV1CompleteOnboardingStepParams";

import type { StoreAgentDetails } from "../../models/storeAgentDetails";

import type { UserOnboarding } from "../../models/userOnboarding";

import type { UserOnboardingUpdate } from "../../models/userOnboardingUpdate";

import { customMutator } from "../../../mutators/custom-mutator";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Onboarding state
 */
export type getV1OnboardingStateResponse200 = {
  data: UserOnboarding;
  status: 200;
};

export type getV1OnboardingStateResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1OnboardingStateResponseSuccess =
  getV1OnboardingStateResponse200 & {
    headers: Headers;
  };
export type getV1OnboardingStateResponseError =
  getV1OnboardingStateResponse401 & {
    headers: Headers;
  };

export type getV1OnboardingStateResponse =
  | getV1OnboardingStateResponseSuccess
  | getV1OnboardingStateResponseError;

export const getGetV1OnboardingStateUrl = () => {
  return `/api/onboarding`;
};

export const getV1OnboardingState = async (
  options?: RequestInit,
): Promise<getV1OnboardingStateResponse> => {
  return customMutator<getV1OnboardingStateResponse>(
    getGetV1OnboardingStateUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1OnboardingStateQueryKey = () => {
  return [`/api/onboarding`] as const;
};

export const getGetV1OnboardingStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1OnboardingState>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1OnboardingState>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1OnboardingStateQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1OnboardingState>>
  > = ({ signal }) => getV1OnboardingState({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1OnboardingState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1OnboardingStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1OnboardingState>>
>;
export type GetV1OnboardingStateQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1OnboardingState<
  TData = Awaited<ReturnType<typeof getV1OnboardingState>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1OnboardingState>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1OnboardingState>>,
          TError,
          Awaited<ReturnType<typeof getV1OnboardingState>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1OnboardingState<
  TData = Awaited<ReturnType<typeof getV1OnboardingState>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1OnboardingState>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1OnboardingState>>,
          TError,
          Awaited<ReturnType<typeof getV1OnboardingState>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1OnboardingState<
  TData = Awaited<ReturnType<typeof getV1OnboardingState>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1OnboardingState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Onboarding state
 */

export function useGetV1OnboardingState<
  TData = Awaited<ReturnType<typeof getV1OnboardingState>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1OnboardingState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1OnboardingStateQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Onboarding state
 */
export const prefetchGetV1OnboardingStateQuery = async <
  TData = Awaited<ReturnType<typeof getV1OnboardingState>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1OnboardingState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1OnboardingStateQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Update onboarding state
 */
export type patchV1UpdateOnboardingStateResponse200 = {
  data: UserOnboarding;
  status: 200;
};

export type patchV1UpdateOnboardingStateResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type patchV1UpdateOnboardingStateResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type patchV1UpdateOnboardingStateResponseSuccess =
  patchV1UpdateOnboardingStateResponse200 & {
    headers: Headers;
  };
export type patchV1UpdateOnboardingStateResponseError = (
  | patchV1UpdateOnboardingStateResponse401
  | patchV1UpdateOnboardingStateResponse422
) & {
  headers: Headers;
};

export type patchV1UpdateOnboardingStateResponse =
  | patchV1UpdateOnboardingStateResponseSuccess
  | patchV1UpdateOnboardingStateResponseError;

export const getPatchV1UpdateOnboardingStateUrl = () => {
  return `/api/onboarding`;
};

export const patchV1UpdateOnboardingState = async (
  userOnboardingUpdate: UserOnboardingUpdate,
  options?: RequestInit,
): Promise<patchV1UpdateOnboardingStateResponse> => {
  return customMutator<patchV1UpdateOnboardingStateResponse>(
    getPatchV1UpdateOnboardingStateUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(userOnboardingUpdate),
    },
  );
};

export const getPatchV1UpdateOnboardingStateMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV1UpdateOnboardingState>>,
    TError,
    { data: UserOnboardingUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV1UpdateOnboardingState>>,
  TError,
  { data: UserOnboardingUpdate },
  TContext
> => {
  const mutationKey = ["patchV1UpdateOnboardingState"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV1UpdateOnboardingState>>,
    { data: UserOnboardingUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return patchV1UpdateOnboardingState(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV1UpdateOnboardingStateMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV1UpdateOnboardingState>>
>;
export type PatchV1UpdateOnboardingStateMutationBody = UserOnboardingUpdate;
export type PatchV1UpdateOnboardingStateMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Update onboarding state
 */
export const usePatchV1UpdateOnboardingState = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV1UpdateOnboardingState>>,
      TError,
      { data: UserOnboardingUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchV1UpdateOnboardingState>>,
  TError,
  { data: UserOnboardingUpdate },
  TContext
> => {
  const mutationOptions =
    getPatchV1UpdateOnboardingStateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Recommended onboarding agents
 */
export type getV1RecommendedOnboardingAgentsResponse200 = {
  data: StoreAgentDetails[];
  status: 200;
};

export type getV1RecommendedOnboardingAgentsResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1RecommendedOnboardingAgentsResponseSuccess =
  getV1RecommendedOnboardingAgentsResponse200 & {
    headers: Headers;
  };
export type getV1RecommendedOnboardingAgentsResponseError =
  getV1RecommendedOnboardingAgentsResponse401 & {
    headers: Headers;
  };

export type getV1RecommendedOnboardingAgentsResponse =
  | getV1RecommendedOnboardingAgentsResponseSuccess
  | getV1RecommendedOnboardingAgentsResponseError;

export const getGetV1RecommendedOnboardingAgentsUrl = () => {
  return `/api/onboarding/agents`;
};

export const getV1RecommendedOnboardingAgents = async (
  options?: RequestInit,
): Promise<getV1RecommendedOnboardingAgentsResponse> => {
  return customMutator<getV1RecommendedOnboardingAgentsResponse>(
    getGetV1RecommendedOnboardingAgentsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1RecommendedOnboardingAgentsQueryKey = () => {
  return [`/api/onboarding/agents`] as const;
};

export const getGetV1RecommendedOnboardingAgentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1RecommendedOnboardingAgentsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>
  > = ({ signal }) =>
    getV1RecommendedOnboardingAgents({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1RecommendedOnboardingAgentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>
>;
export type GetV1RecommendedOnboardingAgentsQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1RecommendedOnboardingAgents<
  TData = Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
          TError,
          Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1RecommendedOnboardingAgents<
  TData = Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
          TError,
          Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1RecommendedOnboardingAgents<
  TData = Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Recommended onboarding agents
 */

export function useGetV1RecommendedOnboardingAgents<
  TData = Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetV1RecommendedOnboardingAgentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Recommended onboarding agents
 */
export const prefetchGetV1RecommendedOnboardingAgentsQuery = async <
  TData = Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1RecommendedOnboardingAgents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetV1RecommendedOnboardingAgentsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Check if onboarding is completed
 */
export type getV1CheckIfOnboardingIsCompletedResponse200 = {
  data: OnboardingStatusResponse;
  status: 200;
};

export type getV1CheckIfOnboardingIsCompletedResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getV1CheckIfOnboardingIsCompletedResponseSuccess =
  getV1CheckIfOnboardingIsCompletedResponse200 & {
    headers: Headers;
  };
export type getV1CheckIfOnboardingIsCompletedResponseError =
  getV1CheckIfOnboardingIsCompletedResponse401 & {
    headers: Headers;
  };

export type getV1CheckIfOnboardingIsCompletedResponse =
  | getV1CheckIfOnboardingIsCompletedResponseSuccess
  | getV1CheckIfOnboardingIsCompletedResponseError;

export const getGetV1CheckIfOnboardingIsCompletedUrl = () => {
  return `/api/onboarding/completed`;
};

export const getV1CheckIfOnboardingIsCompleted = async (
  options?: RequestInit,
): Promise<getV1CheckIfOnboardingIsCompletedResponse> => {
  return customMutator<getV1CheckIfOnboardingIsCompletedResponse>(
    getGetV1CheckIfOnboardingIsCompletedUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetV1CheckIfOnboardingIsCompletedQueryKey = () => {
  return [`/api/onboarding/completed`] as const;
};

export const getGetV1CheckIfOnboardingIsCompletedQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1CheckIfOnboardingIsCompletedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>
  > = ({ signal }) =>
    getV1CheckIfOnboardingIsCompleted({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetV1CheckIfOnboardingIsCompletedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>
>;
export type GetV1CheckIfOnboardingIsCompletedQueryError =
  HTTP401NotAuthenticatedErrorResponse;

export function useGetV1CheckIfOnboardingIsCompleted<
  TData = Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
          TError,
          Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1CheckIfOnboardingIsCompleted<
  TData = Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
          TError,
          Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetV1CheckIfOnboardingIsCompleted<
  TData = Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Check if onboarding is completed
 */

export function useGetV1CheckIfOnboardingIsCompleted<
  TData = Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetV1CheckIfOnboardingIsCompletedQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Check if onboarding is completed
 */
export const prefetchGetV1CheckIfOnboardingIsCompletedQuery = async <
  TData = Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
  TError = HTTP401NotAuthenticatedErrorResponse,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1CheckIfOnboardingIsCompleted>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions =
    getGetV1CheckIfOnboardingIsCompletedQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Submit onboarding profile
 */
export type postV1SubmitOnboardingProfileResponse200 = {
  data: unknown;
  status: 200;
};

export type postV1SubmitOnboardingProfileResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1SubmitOnboardingProfileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1SubmitOnboardingProfileResponseSuccess =
  postV1SubmitOnboardingProfileResponse200 & {
    headers: Headers;
  };
export type postV1SubmitOnboardingProfileResponseError = (
  | postV1SubmitOnboardingProfileResponse401
  | postV1SubmitOnboardingProfileResponse422
) & {
  headers: Headers;
};

export type postV1SubmitOnboardingProfileResponse =
  | postV1SubmitOnboardingProfileResponseSuccess
  | postV1SubmitOnboardingProfileResponseError;

export const getPostV1SubmitOnboardingProfileUrl = () => {
  return `/api/onboarding/profile`;
};

export const postV1SubmitOnboardingProfile = async (
  onboardingProfileRequest: OnboardingProfileRequest,
  options?: RequestInit,
): Promise<postV1SubmitOnboardingProfileResponse> => {
  return customMutator<postV1SubmitOnboardingProfileResponse>(
    getPostV1SubmitOnboardingProfileUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(onboardingProfileRequest),
    },
  );
};

export const getPostV1SubmitOnboardingProfileMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1SubmitOnboardingProfile>>,
    TError,
    { data: OnboardingProfileRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1SubmitOnboardingProfile>>,
  TError,
  { data: OnboardingProfileRequest },
  TContext
> => {
  const mutationKey = ["postV1SubmitOnboardingProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1SubmitOnboardingProfile>>,
    { data: OnboardingProfileRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postV1SubmitOnboardingProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1SubmitOnboardingProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1SubmitOnboardingProfile>>
>;
export type PostV1SubmitOnboardingProfileMutationBody =
  OnboardingProfileRequest;
export type PostV1SubmitOnboardingProfileMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Submit onboarding profile
 */
export const usePostV1SubmitOnboardingProfile = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1SubmitOnboardingProfile>>,
      TError,
      { data: OnboardingProfileRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1SubmitOnboardingProfile>>,
  TError,
  { data: OnboardingProfileRequest },
  TContext
> => {
  const mutationOptions =
    getPostV1SubmitOnboardingProfileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reset onboarding progress
 */
export type postV1ResetOnboardingProgressResponse200 = {
  data: UserOnboarding;
  status: 200;
};

export type postV1ResetOnboardingProgressResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1ResetOnboardingProgressResponseSuccess =
  postV1ResetOnboardingProgressResponse200 & {
    headers: Headers;
  };
export type postV1ResetOnboardingProgressResponseError =
  postV1ResetOnboardingProgressResponse401 & {
    headers: Headers;
  };

export type postV1ResetOnboardingProgressResponse =
  | postV1ResetOnboardingProgressResponseSuccess
  | postV1ResetOnboardingProgressResponseError;

export const getPostV1ResetOnboardingProgressUrl = () => {
  return `/api/onboarding/reset`;
};

export const postV1ResetOnboardingProgress = async (
  options?: RequestInit,
): Promise<postV1ResetOnboardingProgressResponse> => {
  return customMutator<postV1ResetOnboardingProgressResponse>(
    getPostV1ResetOnboardingProgressUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV1ResetOnboardingProgressMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1ResetOnboardingProgress>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1ResetOnboardingProgress>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postV1ResetOnboardingProgress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1ResetOnboardingProgress>>,
    void
  > = () => {
    return postV1ResetOnboardingProgress(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1ResetOnboardingProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1ResetOnboardingProgress>>
>;

export type PostV1ResetOnboardingProgressMutationError =
  HTTP401NotAuthenticatedErrorResponse;

/**
 * @summary Reset onboarding progress
 */
export const usePostV1ResetOnboardingProgress = <
  TError = HTTP401NotAuthenticatedErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1ResetOnboardingProgress>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1ResetOnboardingProgress>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getPostV1ResetOnboardingProgressMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Complete onboarding step
 */
export type postV1CompleteOnboardingStepResponse200 = {
  data: unknown;
  status: 200;
};

export type postV1CompleteOnboardingStepResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postV1CompleteOnboardingStepResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postV1CompleteOnboardingStepResponseSuccess =
  postV1CompleteOnboardingStepResponse200 & {
    headers: Headers;
  };
export type postV1CompleteOnboardingStepResponseError = (
  | postV1CompleteOnboardingStepResponse401
  | postV1CompleteOnboardingStepResponse422
) & {
  headers: Headers;
};

export type postV1CompleteOnboardingStepResponse =
  | postV1CompleteOnboardingStepResponseSuccess
  | postV1CompleteOnboardingStepResponseError;

export const getPostV1CompleteOnboardingStepUrl = (
  params: PostV1CompleteOnboardingStepParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/onboarding/step?${stringifiedParams}`
    : `/api/onboarding/step`;
};

export const postV1CompleteOnboardingStep = async (
  params: PostV1CompleteOnboardingStepParams,
  options?: RequestInit,
): Promise<postV1CompleteOnboardingStepResponse> => {
  return customMutator<postV1CompleteOnboardingStepResponse>(
    getPostV1CompleteOnboardingStepUrl(params),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostV1CompleteOnboardingStepMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1CompleteOnboardingStep>>,
    TError,
    { params: PostV1CompleteOnboardingStepParams },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1CompleteOnboardingStep>>,
  TError,
  { params: PostV1CompleteOnboardingStepParams },
  TContext
> => {
  const mutationKey = ["postV1CompleteOnboardingStep"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1CompleteOnboardingStep>>,
    { params: PostV1CompleteOnboardingStepParams }
  > = (props) => {
    const { params } = props ?? {};

    return postV1CompleteOnboardingStep(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1CompleteOnboardingStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1CompleteOnboardingStep>>
>;

export type PostV1CompleteOnboardingStepMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

/**
 * @summary Complete onboarding step
 */
export const usePostV1CompleteOnboardingStep = <
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1CompleteOnboardingStep>>,
      TError,
      { params: PostV1CompleteOnboardingStepParams },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postV1CompleteOnboardingStep>>,
  TError,
  { params: PostV1CompleteOnboardingStepParams },
  TContext
> => {
  const mutationOptions =
    getPostV1CompleteOnboardingStepMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
